import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from '../../../services/common.service';
import { ApiService } from '../../../services/api.service';
import { Location, DatePipe } from '@angular/common';
import * as moment from "moment";

@Component({
  selector: 'app-contract-company-detail',
  templateUrl: './contract-company-detail.page.html',
  styleUrls: ['./contract-company-detail.page.scss'],
})
export class ContractCompanyDetailPage implements OnInit {
  contractComopanyForm: FormGroup;
  submitted = false;
  contractCompanyId: string;
  contractCompanyLocale: any = {};
  contractCompany: any = {};
  tempContractCompany: any = {}
  showPage: boolean = false;

  locale: any;
  tempLocale: any;

  startDate: any;
  endDate: any;
  disableCompany: boolean = false;
  LegalFormList: any = [];
  controlStatus: any = {
    ResidenceAddressZipCode: false,
    EmailAddress: false,
    Phone: false,
    WebsiteURL: false,
    BillingAddressZipCode: false
  };





  config: any = {
    fontNames: ['Arial', 'Arial Black', 'Comic Sans MS', 'Courier New', 'Helvetica', 'Roboto', 'sans-serif;', 'Times New Roman', 'Verdana'],
    height: 300,
    toolbar: [
      ['headline', ['style']],
      ['misc', ['codeview', 'undo', 'redo', 'codeBlock']],
      ['font', ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript', 'clear']],
      ['fontsize', ['fontname', 'fontsize', 'color']],
      ['para', ['style0', 'ul', 'ol', 'paragraph', 'height']],
      ['insert', ['picture','video', 'link']],
      ['table', ['table']]
    ]
  };


  constructor(private router: Router, private route: ActivatedRoute,
    private datePipe: DatePipe, private formBuilder: FormBuilder, private _apiService: ApiService, public _commonService: CommonService, private location: Location) { }


  ngOnInit() {
    this.contractComopanyForm = this.formBuilder.group({
      Name: ['', Validators.required],
      KvkNumber: [''],
      KvkResidenceNumber: [''],
      WebsiteURL: ['', [Validators.pattern(this._commonService.URLPattern)]],
      EstablishmentType: [''],
      ShowDashboard: [true],
      EmailAddress: ['', [Validators.required, Validators.email]],
      Fax: [''],
      Phone: ['', [Validators.pattern(this._commonService.phonePattern)]],
      SbiCode1: [''],
      SbiCode2: [''],
      
      BillingAddressCity: [''],
      BillingAddressCountry: [''],
      BillingAddressStreet: [''],
      BillingAddressStreetNumber: [''],
      BillingAddressZipCode: ['', [Validators.pattern(this._commonService.postalCodePattern)]],
      ResidenceAddressStreet: ['', Validators.required],
      ResidenceAddressStreetNumber: ['', Validators.required],
      ResidenceAddressCity: ['', Validators.required],
      ResidenceAddressZipCode: ['', [Validators.required, Validators.pattern(this._commonService.postalCodePattern)]],
      ResidenceAddressCountry: ['', Validators.required],
      Representative: [''],
      LegalFormId: [''],

    });
  }

  ionViewDidEnter() {
    
    this.disableCompany = false;
    this.contractCompanyId = this.route.snapshot.paramMap.get('id');
    this.locale = Number((localStorage.locale && localStorage.locale != '') ? localStorage.locale : 1043);
    if(this.locale == 1043) {
      this.config.lang = 'nl-NL';
    }
    this.tempLocale = this.locale;
    if (this.contractCompanyId == '0') {
      this.contractCompanyId = null;
    }
    if (this.contractCompanyId) {
      this.getContractCompanyDetails();
    }else{
      this.getLocales();
      this.getLegalForm();
      this.showPage = true;
      this.contractCompany =
        {
          ContractCompanyId: this.contractCompanyId,
          ShowDashboard: "1",
          KvkNumber: '',
          KvkResidenceNumber: '',
          EmailAddress: '',
          Fax: '',
          EstablishmentType: '',
          Phone: '',
          WebsiteURL: '',
          SbiCode1: '',
          SbiCode2: '',
          BillingAddressCity: '',
          BillingAddressCountry: '',
          BillingAddressStreet: '',
          BillingAddressStreetNumber: '',
          BillingAddressZipCode: '',
          ResidenceAddressStreet: '',
          ResidenceAddressStreetNumber: '',
          ResidenceAddressCity: '',
          ResidenceAddressZipCode: '',
          ResidenceAddressCountry: '',
          Representative: '',
          LegalFormId: '',
    
          Translations: [
            {
              Title: "",
              Description: "",
              LocaleId: this.locale,
            }
          ]
        }
    }
  }

  async getLocales() {
    try {
      if (localStorage.domainLocales) {
        this.contractCompanyLocale.AllLocales = JSON.parse(localStorage.domainLocales);
      } else {
        let localeData = await this._apiService.getDomainLocales('', 1, 0);
        this.contractCompanyLocale.AllLocales = localeData.body;
        localStorage.domainLocales = JSON.stringify(localeData.body);
      }
    } catch (error) {
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  async getContractCompanyDetails() {
    try {
      this._commonService.presentLoading();
      let res = await this._apiService.getContractCompanyDetail(this.contractCompanyId);
      this.contractCompany = res.body;
      this.tempContractCompany = res.body;
      await this.getLocales();
      await this.getLegalForm();
      this._commonService.log(this.contractCompany, this._commonService.LOG);

       this.contractComopanyForm.patchValue({
        BillingAddressCity: this.contractCompany.BillingAddressCity,
        BillingAddressCountry: this.contractCompany.BillingAddressCountry,
        BillingAddressStreet: this.contractCompany.BillingAddressStreet,
        BillingAddressStreetNumber: this.contractCompany.BillingAddressStreetNumber,
        BillingAddressZipCode: this.contractCompany.BillingAddressZipCode,
        // EmailAddress: this.contractCompany.EmailAddress,
        ResidenceAddressStreet: this.contractCompany.ResidenceAddressStreet,
        ResidenceAddressStreetNumber: this.contractCompany.ResidenceAddressStreetNumber,
        ResidenceAddressCity: this.contractCompany.ResidenceAddressCity,
        ResidenceAddressZipCode: this.contractCompany.ResidenceAddressZipCode,
        ResidenceAddressCountry: this.contractCompany.ResidenceAddressCountry,
        KvkNumber: this.contractCompany.KvkNumber,
        KvkResidenceNumber: this.contractCompany.KvkResidenceNumber,
        EmailAddress: this.contractCompany.EmailAddress,
        Fax: this.contractCompany.Fax,
        ShowDashboard: this.contractCompany.ShowDashboard,
        Name: this.contractCompany.Name,
        EstablishmentType: this.contractCompany.EstablishmentType,
        WebsiteURL: this.contractCompany.WebsiteURL,
        Phone: this.contractCompany.Phone,
        SbiCode1: this.contractCompany.SbiCode1,
        SbiCode2: this.contractCompany.SbiCode2,
        Representative: this.contractCompany.Representative,
        LegalFormId: this.contractCompany.LegalFormId,
        });

      this.contractComopanyForm.updateValueAndValidity();
      this.showPage = true;
      this._commonService.dismiss();
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR)
    }
  }

  onBlurMethod(controlName){
    
    if(controlName == 'ResidenceAddressZipCode'){
      this.controlStatus.ResidenceAddressZipCode = true
    }
    if(controlName == 'EmailAddress'){
     this.controlStatus.EmailAddress = true
   }
   if(controlName == 'Phone'){
    this.controlStatus.Phone = true
  }
  if(controlName == 'WebsiteURL'){
    this.controlStatus.WebsiteURL = true
  }
  if(controlName == 'BillingAddressZipCode'){
    this.controlStatus.BillingAddressZipCode = true
  }
   }
 
   onFocusMethod(controlName){
     if(controlName == 'ResidenceAddressZipCode'){
       this.controlStatus.ResidenceAddressZipCode = false
     }
     if(controlName == 'EmailAddress'){
       this.controlStatus.EmailAddress = false
     }
     if(controlName == 'Phone'){
      this.controlStatus.Phone = false
    }
    if(controlName == 'WebsiteURL'){
      this.controlStatus.WebsiteURL = false
    }
    if(controlName == 'BillingAddressZipCode'){
      this.controlStatus.BillingAddressZipCode = false
    }
   }


  get f() { return this.contractComopanyForm.controls; }

  async onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.contractComopanyForm.invalid) {
      this._commonService.scrollToError();
      this.controlStatus.ResidenceAddressZipCode = true
      this.controlStatus.EmailAddress = true
      this.controlStatus.Phone = true
      this.controlStatus.BillingAddressZipCode = true
      this.controlStatus.WebsiteURL = true
      return;
    }
    this._commonService.presentLoading();
    try {
      this.contractCompany.Name = this.contractComopanyForm.value.Name;

      this.contractCompany.KvkResidenceNumber = this.contractComopanyForm.value.KvkResidenceNumber;
      this.contractCompany.KvkNumber = this.contractComopanyForm.value.KvkNumber;
      this.contractCompany.EmailAddress = this.contractComopanyForm.value.EmailAddress.trim();
      this.contractCompany.Phone = this.contractComopanyForm.value.Phone;
      this.contractCompany.SbiCode1 = this.contractComopanyForm.value.SbiCode1;
      this.contractCompany.SbiCode2 = this.contractComopanyForm.value.SbiCode2;
      this.contractCompany.ShowDashboard = this.contractComopanyForm.value.ShowDashboard;
      this.contractCompany.EstablishmentType = this.contractComopanyForm.value.EstablishmentType;
      this.contractCompany.WebsiteURL = this.contractComopanyForm.value.WebsiteURL;
      this.contractCompany.ContractCompanyId = this.contractCompanyId ? this.contractCompanyId: null;

      this.contractCompany.BillingAddressCountry = this.contractComopanyForm.value.BillingAddressCountry;
      this.contractCompany.BillingAddressStreet = this.contractComopanyForm.value.BillingAddressStreet;
      this.contractCompany.BillingAddressStreetNumber = this.contractComopanyForm.value.BillingAddressStreetNumber;
      this.contractCompany.BillingAddressCity = this.contractComopanyForm.value.BillingAddressCity;
      this.contractCompany.BillingAddressZipCode = this.contractComopanyForm.value.BillingAddressZipCode;
      this.contractCompany.ResidenceAddressStreet = this.contractComopanyForm.value.ResidenceAddressStreet;
      this.contractCompany.ResidenceAddressStreetNumber = this.contractComopanyForm.value.ResidenceAddressStreetNumber;
      this.contractCompany.ResidenceAddressCity = this.contractComopanyForm.value.ResidenceAddressCity;
      this.contractCompany.ResidenceAddressZipCode = this.contractComopanyForm.value.ResidenceAddressZipCode;
      this.contractCompany.ResidenceAddressCountry = this.contractComopanyForm.value.ResidenceAddressCountry;
      this.contractCompany.Representative = this.contractComopanyForm.value.Representative;
      this.contractCompany.LegalFormId = this.contractComopanyForm.value.LegalFormId;

      let res = await this._apiService.postContractCompany(this.contractCompany);
      if(res){
        if (res.id) {
          this.contractCompanyId = res.id;
          this.location.replaceState('maintenance/contractcompanies/' + this.contractCompanyId);
        }
      }
      this._commonService.dismiss();
      this._commonService.showToast(this._commonService.getLocalTranslation('label-recordSaved'));
      this._commonService.log(this.contractCompany, this._commonService.LOG);
      this.submitted = false;
      this.getContractCompanyDetails();
      // save to localstorage
      //this._commonService.getcontractCompany();
    } catch (error) {
      if(error.status >= 500 && error.status < 600){
        
       this.contractComopanyForm.patchValue({
        BillingAddressCity: this.tempContractCompany.BillingAddressCity,
        BillingAddressCountry: this.tempContractCompany.BillingAddressCountry,
        BillingAddressStreet: this.tempContractCompany.BillingAddressStreet,
        BillingAddressStreetNumber: this.tempContractCompany.BillingAddressStreetNumber,
        BillingAddressZipCode: this.tempContractCompany.BillingAddressZipCode,
        // EmailAddress: this.contractCompany.EmailAddress,
        ResidenceAddressStreet: this.tempContractCompany.ResidenceAddressStreet,
        ResidenceAddressStreetNumber: this.tempContractCompany.ResidenceAddressStreetNumber,
        ResidenceAddressCity: this.tempContractCompany.ResidenceAddressCity,
        ResidenceAddressZipCode: this.tempContractCompany.ResidenceAddressZipCode,
        ResidenceAddressCountry: this.tempContractCompany.ResidenceAddressCountry,
        KvkNumber: this.tempContractCompany.KvkNumber,
        KvkResidenceNumber: this.tempContractCompany.KvkResidenceNumber,
        EmailAddress: this.tempContractCompany.EmailAddress,
        Fax: this.tempContractCompany.Fax,
        ShowDashboard: this.tempContractCompany.ShowDashboard,
        Name: this.tempContractCompany.Name,
        EstablishmentType: this.tempContractCompany.EstablishmentType,
        WebsiteURL: this.tempContractCompany.WebsiteURL,
        Phone: this.tempContractCompany.Phone,
        SbiCode1: this.tempContractCompany.SbiCode1,
        SbiCode2: this.tempContractCompany.SbiCode2,
        Representative: this.tempContractCompany.Representative,
        LegalFormId: this.tempContractCompany.LegalFormId,
        });
      }
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  delete() {
    this._commonService.presentAlertConfirm()
      .then(async (res) => {
        try {
          this._commonService.presentLoading();
          await this._apiService.deletContractCompany(this.contractCompanyId);
          this._commonService.dismiss();
          this._commonService.log(res, this._commonService.LOG);
          this.goBack();
        } catch (error) {
          this._commonService.dismiss();
          this._commonService.log(error, this._commonService.ERROR);
        }
      })
      .catch((err) => {
        this._commonService.log(err, this._commonService.LOG);
      })
  }


  goBack() {
    this.location.back();
  }

  changeLocale() {
    if (this.showPage) {
      if (this.contractCompanyId && this.contractCompany.Translations) {
        let tempContractCompany = this.contractCompany.Translations.find(x => x.LocaleId == this.tempLocale);
        tempContractCompany.Name = this.contractComopanyForm.value.Name;
        this.tempLocale = this.locale;
        let company = this.contractCompany.Translations.find(x => x.LocaleId == this.locale);
        if (company) {
          this.contractComopanyForm.patchValue({
            Name: company.Name,
          });
        } else {
          this.contractCompany.Translations.push({
            Title: '',
            Description: '',
            LocaleId: this.locale,
          });
          this.contractComopanyForm.controls['Name'].reset();
        }
      } else {
        let tempContractCompany = this.contractCompany.Translations.find(x => x.LocaleId == this.tempLocale);
        if (tempContractCompany) {
          tempContractCompany.Name = this.contractComopanyForm.value.Name;
          this.tempLocale = this.locale;
          let company = this.contractCompany.Translations.find(x => x.LocaleId == this.locale);
          if (company) {
            this.contractComopanyForm.patchValue({
              Name: company.Name,
            });
          }
          else {
            this.contractCompany.Translations.push({
              Title: '',
              Description: '',
              LocaleId: this.locale,
            });
            this.contractComopanyForm.controls['Name'].reset();
            this.tempLocale = this.locale;
          }
        }
      }
    }
  }
  async getLegalForm() {
    try {
      if (localStorage.LegalFormList) {
        this.LegalFormList  = JSON.parse(localStorage.LegalFormList);
      } else {
        let legalForm = await this._apiService.getLegalForm();
        this.LegalFormList = legalForm.body;
        localStorage.setItem('LegalFormList', JSON.stringify(legalForm.body));
      }            
       
    } catch (error) {
      this._commonService.log(error, this._commonService.ERROR);
    }
  }
  
  onChangeBreadcrumb() {
      this.contractCompany.Name = this.contractComopanyForm.value.Name;
  }

  onActionChange(obj) {

    switch (obj.Action) {
      case "save":
        this.onSubmit();
        break;
      case "delete":
        this.delete();
        break;
      case "backToList":
        this.goBack();
        break;
      case "backToMain":
        this.router.navigate(['maintenance'], { replaceUrl: true })
        break;
      case "back":
        this.goBack();
        break;
    }

  }

  copyAddress(){
    this.contractComopanyForm.patchValue({
      BillingAddressCity: this.contractComopanyForm.get('ResidenceAddressCity').value,
      BillingAddressCountry: this.contractComopanyForm.get('ResidenceAddressCountry').value,
      BillingAddressStreet: this.contractComopanyForm.get('ResidenceAddressStreet').value,
      BillingAddressStreetNumber: this.contractComopanyForm.get('ResidenceAddressStreetNumber').value,
      BillingAddressZipCode: this.contractComopanyForm.get('ResidenceAddressZipCode').value
      })
  }
}
